import { CentraSelectionItem } from "@frend-digital/centra-legacy/schemas/selection/selectionProductSchema";
import type { CentraSelection } from "@frend-digital/centra-legacy/schemas/selection/selectionSchema";

import { GeneratedCartItem, generateCartItem } from "../localAtomics";
import { generateCartSummary } from "../selectionAtoms";

const sortWeights: { [key: string]: number } = {
  recipe: 0,
  booklet: 0,
  yarn: 1,
  accessory: 2,
  default: 3,
};

const getSortWeight = (item: GeneratedCartItem) => {
  const type = item?.type;
  return sortWeights[type] ?? sortWeights["default"];
};

const groupItems = (items?: GeneratedCartItem[]) => {
  const groups = items?.reduce(
    (
      groups: {
        [key: string]: GeneratedCartItem[];
      },
      item: GeneratedCartItem,
    ) => {
      const key = item?.comment
        ? (JSON.parse(item?.comment ?? "")?.id ?? "default")
        : "default";

      if (!groups[key]) {
        groups[key] = [];
      }
      groups[key].push(item);

      groups[key].sort((a, b) => {
        const aWeight = getSortWeight(a);
        const bWeight = getSortWeight(b);
        return aWeight - bWeight;
      });

      return groups;
    },
    {},
  );

  if (!groups) {
    return [];
  }

  // TODO: Consider using object indexed by id instead of array to improve performance
  const groupedItems = Object?.keys(groups).map(key => {
    return {
      id: key,
      itemsIds: groups[key].map(item => item.id),
      items: groups[key],
    };
  });

  return groupedItems;
};

const formatSelection = (data: CentraSelection) => {
  const formattedItems = data?.selection?.items?.map(
    (item: CentraSelectionItem) => generateCartItem(item),
  );

  const groupedItems = groupItems(formattedItems);

  const summary = generateCartSummary(data);

  const formattedData = {
    ...data,
    selection: {
      ...data.selection,
      items: groupedItems,
      summary,
    },
  };

  return formattedData;
};

export default formatSelection;

export type FormattedSelection = ReturnType<typeof formatSelection>;

export type FormattedSelectionItems = FormattedSelection["selection"]["items"];

export type ItemGroup = FormattedSelectionItems[number];

export type GroupSubItem = ItemGroup["items"][number];
